module.exports = __webpack_public_path__ + "static/media/Rollo 3.958fa023.jpg";